import { FormattedMessage } from "react-intl";
import Markdown from "react-markdown";
import OffScreen from "../../../../common/core-ui/OffScreen.tsx";

export default function ServiceAnnouncementBannerBody({
  body,
}: {
  body: string | null;
}) {
  if (!body) {
    return null;
  }

  return (
    <Markdown
      allowedElements={["a", "p"]}
      unwrapDisallowed={true}
      components={{
        a: ({ children, node, ...rest }) => (
          <a
            className="vst-link"
            target="_blank"
            rel="noopener noreferrer"
            {...rest}
          >
            {children}
            <OffScreen tagName="span">
              <FormattedMessage defaultMessage="(opens in a new window)" />
            </OffScreen>
          </a>
        ),
      }}
    >
      {body}
    </Markdown>
  );
}
